<template>
  <div class="mvc-add">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="130px">
      <div class="base-info-box">
        <div class="title">基础信息</div>
        <el-form-item label="商品名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入商品名称（最多10个字符）" maxLength="10" />
        </el-form-item>
        <el-form-item label="图片" prop="picture">
          <UploadImg name="picture" @getUploadFile="getUploadFile" :uploadUrl="form.picture" desc="建议：上传145*100的jpg、png、jpeg图片"></UploadImg>
        </el-form-item>
        <el-form-item label="数据来源" prop="source">
          <el-radio-group v-model="form.source" :disabled="!!form.skuId" @change="sourceChange">
            <el-radio label="Runtu">闰土自制</el-radio>
            <el-radio label="Middleground">券中台投放</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="储值卡" prop="storedCardTemplateId">
          <el-select v-model="form.storedCardTemplateId" placeholder="请选择储值卡" @change="onValueCardChange" :disabled="!!form.skuId" filterable>
            <el-option v-for="item in cardListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span class="input-remark ml10">支付宝暂不支持赠券、赠金+券类型的储值卡</span>
        </el-form-item>
        <el-form-item label="">
          <Table :tableThData="tableThData" :tableTrData="tableTrData" :pagination="false" >
            <template #id="{ row }">{{ row.id }}</template>
            <template #name="{ row }">{{ row.name }}</template>
            <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
            <template #amount="{ row }">{{ row.amount }}</template>
            <template #giveType="{ row }">{{ row.giveType || '---'}}</template>
            <template #allowAllocateQuantity="{ row }">{{ row.allowAllocateQuantity }}</template>
            <template #effectiveStr="{ row }">
              <div>{{ row.effectiveStr }}</div>
            </template>
          </Table>
        </el-form-item>
        <el-form-item label="上架渠道" prop="platform">
          <el-radio-group v-model="form.platform" :disabled="!!form.skuId">
            <el-radio label="WechatMiniapp">微信小程序</el-radio>
            <el-radio label="AlipayMiniapp">支付宝小程序</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item  prop="syncChannel">
            <span slot="label">
              <span class="span-box">
                <span>是否同步首页</span>
                  <el-tooltip class="item" effect="dark" placement="bottom">
                    <div slot="content">
                      “是”表示该商品在礼品卡商城及首页礼品卡展示<br/>
                      “否”表示该商品只在礼品卡商城展示<br/>
                    </div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
              </span>
            </span>
           <el-radio-group  v-model="form.syncChannel"  @change="onDeliveryChannelChange">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="sort" v-if="form.syncChannel">
          <span slot="label">
            <span class="span-box">
              <span>活动顺序</span>
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div slot="content">排序规则只在首页礼品卡有效，礼品卡商城不生效</div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </span>
          <el-input v-model="form.sortNum" placeholder="请输入活动顺序"  oninput="value=value.replace(/^(0+)|[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item v-if="form.platform == 'AlipayMiniapp'" label="支付宝活动ID" prop="outAssociationId">
          <el-input v-model="form.outAssociationId" placeholder="请输入支付宝活动ID" />
        </el-form-item>
        <el-form-item v-if="form.platform == 'AlipayMiniapp'" label="活动链接" prop="outAssociationUrl">
          <el-input v-model="form.outAssociationUrl" placeholder="请输入活动链接" />
        </el-form-item>
        <el-form-item label="上架数量" prop="quantity" >
          <el-input type="text" v-model="form.quantity" placeholder="请输入上架数量" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
          <span v-if="currentSelectCard.allowAllocateQuantity" class="input-remark ml10">剩余可分配数量：{{currentSelectCard.allowAllocateQuantity}}张</span>
        </el-form-item>
        <el-form-item label="每人限购次数" prop="limitType" >
          <el-radio-group v-model="form.limitType" @change="limitTypeChange">
            <el-radio label="noLimit">无限制</el-radio>
            <el-radio label="userLimit">每人总限购</el-radio>
            <el-radio label="regionLimit">阶段性限购</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="form.limitType == 'userLimit'" style="margin-left: 230px;">
          <el-form-item label="" prop="userTotalLimit" label-width="0">
            <el-input type="text" v-model="form.userTotalLimit" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')">
              <template slot="append">次</template>
            </el-input>
          </el-form-item>
        </div>
        <div v-if="form.limitType == 'regionLimit'" style="margin-left: 350px;" class="assign-day">
          <el-form-item label="" prop="intervalLimitDays" label-width="0">
            <el-input type="text" v-model="form.intervalLimitDays" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')">
              <template slot="prepend">每</template>
              <template slot="append">天内限购</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="userIntervalLimit" label-width="0">
            <el-input type="text" v-model="form.userIntervalLimit" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')">
              <template slot="append">次</template>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item label="售卖时间" prop="salesTime">
          <el-date-picker
            v-model="form.salesTime"
            type="daterange"
            range-separator=""
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy/MM/dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="优惠" prop="discount" >
          <el-input type="text" v-model="form.discount" placeholder="请输入优惠金额" :disabled="!!form.skuId" oninput="value=value.replace(/[^.\d.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="" >
          <span v-if="form.platform == 'WechatMiniapp'">售价 = 面值 - 优惠</span>
          <span v-if="form.platform == 'AlipayMiniapp'">售价 = 面值</span>
        </el-form-item>
      <auth-button auth="storedCard:mall:share:commission">
        <el-form-item label="分销佣金规则" prop="commissionType" >
          <el-radio-group v-model="form.commissionType" @change="commissionTypeChange">
            <el-radio label="None">不配置分销佣金</el-radio>
            <el-radio label="First">配置一级分拥</el-radio>
            <el-radio label="Second">配置二级分佣</el-radio>
          </el-radio-group>
        </el-form-item>
         <div v-if="form.commissionType == 'First' || form.commissionType == 'Second'"  :style="form.commissionType == 'First' ?'margin-left: 260px;':'margin-left: 400px;'">
          <el-form-item label="店铺分销佣金" prop="storeCommission" label-width="120px">
            <el-input type="text" v-model="form.storeCommission" placeholder="0.00" oninput="value=value.replace(/[^.\d.]/g,'')" @blur="returnFloat('storeCommission', form.storeCommission)">
              <template slot="append">元/每张</template>
            </el-input>
          </el-form-item>
          </div>
        <div v-if="form.commissionType == 'First' || form.commissionType == 'Second'" :style="form.commissionType == 'First' ?'margin-left: 260px;':'margin-left: 400px;'">
          <el-form-item label="用户分销佣金" prop="commission" label-width="120px">
            <el-input type="text" v-model="form.commission" placeholder="0.00" oninput="value=value.replace(/[^.\d.]/g,'')" @blur="returnFloat('commission', form.commission)">
             <template slot="append">元/每张</template></el-input>
          </el-form-item>
        </div>
        <div v-if="form.commissionType == 'Second'" style="margin-left: 400px;">
          <el-form-item label="二级分销佣金" prop="secondaryCommission" label-width="120px">
            <el-input type="text" v-model="form.secondaryCommission" placeholder="0.00" oninput="value=value.replace(/[^.\d.]/g,'')" @blur="returnFloat('secondaryCommission', form.secondaryCommission)">
             <template slot="append">元/每张</template></el-input>
          </el-form-item>
        </div>
        <div v-if="form.commissionType == 'Second'" style="margin-left: 520px;" class="commission-remark">注：二级分销佣金的受益人是分销用户的邀请人！</div>
        <el-form-item label="邀请人分佣规则" prop="inviterCommissionType" >
          <el-radio-group v-model="form.inviterCommissionType" @change="inviterCommissionTypeChange">
            <el-radio label="None">不配置邀请人佣金</el-radio>
            <el-radio label="First">配置邀请人佣金</el-radio>
          </el-radio-group>
        </el-form-item>
         <div v-if="form.inviterCommissionType == 'First'" style="margin-left: 260px;">
          <el-form-item label="邀请人佣金" prop="inviterCommission" label-width="120px">
            <el-input type="text" v-model="form.inviterCommission" placeholder="0.00" oninput="value=value.replace(/[^.\d.]/g,'')" @blur="returnFloat('inviterCommission', form.inviterCommission)">
              <template slot="append">元/每张</template>
            </el-input>
          </el-form-item>
          </div>
          <div v-if="form.inviterCommissionType == 'First'" style="margin-left: 380px;" class="commission-remark">注：邀请人佣金的受益人是直接消费用户的邀请人！</div>
        </auth-button>
      </div>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="mr20">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import Table from "@/components/Table/index";
import AuthButton from '@/components/AuthButton'
import { api_getEfficientValueCardList, api_postValueCardStoreAdd, api_getValueCardStoreDetail, api_postValueCardStoreUpdate } from '@/api/valueCardStore'
import { api_postFileUpload } from '@/api/common'
export default {
  name: "mvcAdd",
  components: {
    UploadImg,
    Table,
    AuthButton
  },
  data() {
    // 校验图片
    const checkFail = (rule, value, callback) => {
      if (rule.field == 'picture' && !this.form.picture) {
        callback(new Error('请上传图片'))
      } else {
        callback()
      }
    }

    // 校验上架数量
    const checkQuantity = (rule, value, callback) => {
      let limitQuantity = this.form.skuId ? this.currentQuantity + this.currentSelectCard.allowAllocateQuantity : this.currentSelectCard.allowAllocateQuantity
      if (!value) {
        callback(new Error('请输入上架数量'))
      } else if (value == '0') {
        callback(new Error('上架数量不能为0'))
      } else if (this.currentQuantity && value * 1 < this.currentQuantity) {
        callback(new Error('上架数量不能减少'))
      } else if (value * 1 > limitQuantity) {
        callback(new Error('最多可上架数量：' + limitQuantity + '张'))
      } else {
        callback()
      }
    }

    // 校验支付宝活动ID
    const checkOutAssociationId = (rule, value, callback) => {
      if (!value && this.form.outAssociationUrl) {
        callback(new Error('请输入支付宝活动ID'))
      } else {
        callback()
      }
    }

    // 校验支付宝活动ID
    const checkOutAssociationUrl = (rule, value, callback) => {
      if (!value && this.form.outAssociationId) {
        callback(new Error('请输入活动链接'))
      } else {
        callback()
      }
    }

    // 校验优惠
    const checkDiscount = (rule, value, callback) => {
      if (!(value + '')) {
        callback(new Error('请输入优惠'))
      } else if (this.form.platform === 'WechatMiniapp' && (this.currentSelectCard.amount * 1000000 - value * 1000000 < 100000)) {
        callback(new Error('售价不能小于0.1元（售价 = 面值 - 优惠）'))
      } else {
        callback()
      }
    }
    // 校验分销
    const commission = (rule, value, callback) => {
      let discount = this.form.discount || 0
      let payAmount = 0
      this.form.platform === 'WechatMiniapp' ? payAmount = this.currentSelectCard.amount * 1000000 - discount * 1000000 : payAmount = this.currentSelectCard.amount * 1000000
      if (!(value + '')) {
        callback()
      } else if (value * 1000000 > payAmount*0.5) {
        // callback(new Error('您设置的佣金金额过大,佣金金额不能大于售价的50%'))
        callback()
      } else {
        callback()
      }
    }

    return {
      submitLoading: false,
      form: {
        effective: 0,
        syncChannel:false,
        storeCommission: '',
        commission: '',
        source: 'Runtu',
        inviterCommission:'',
        secondaryCommission:'',
        limitType: 'noLimit',
        commissionType:'None',
        inviterCommissionType:'None',
        userTotalLimit: '',
        userIntervalLimit: '',
        intervalLimitDays: '',
      },
      rules: {
        name: [{ required: true, message: '请输入商品名称' }],
        picture: [{ validator: checkFail }],
        storedCardTemplateId: [{ required: true, message: '请选择储值卡' }],
        platform: [{ required: true, message: '请选择上架渠道' }],
        outAssociationId: [{ validator: checkOutAssociationId }],
        outAssociationUrl: [{ validator: checkOutAssociationUrl }],
        quantity: [{ validator: checkQuantity }],
        salesTime: [{ required: true, message: '请选择售卖时间' }],
        discount: [{ validator: checkDiscount }],
        commission: [{ validator: commission }],
        storeCommission: [{ validator: commission }],
        inviterCommission: [{ validator: commission }],
        secondaryCommission: [{ validator: commission }],
        userTotalLimit: [{ required: true, message: '请输入限购次数' }],
        userIntervalLimit: [{ required: true, message: '请输入限购次数' }],
        intervalLimitDays: [{ required: true, message: '请输入天数' }],
      },
      cardListData: [], // 储值卡list数据
      cardListData_rt: [], // 储值卡list数据--闰土自制
      cardListData_vc: [], // 储值卡list数据--券中台投放
      currentSelectCard: {}, // 当前选择的储值卡数据
      tableThData: [
        { prop: "id", label: "储值卡ID", minWidth: "80", },
        { prop: "name", label: "储值卡名称", minWidth: "120", },
        { prop: "useRangeType", label: "使用范围", minWidth: "120", },
        { prop: "amount", label: "面值（元）", minWidth: "100", },
        { prop: "giveType", label: "赠礼类型", minWidth: "100", },
        { prop: "allowAllocateQuantity", label: "可分配数量", minWidth: "100",},
        { prop: "effectiveStr", label: "卡有效时间", minWidth: "120",},
      ],
      tableTrData: [],
      currentQuantity: '', // 当前上架数量
    };
  },
  async created() {
    if (this.$route.query.skuId) {
      this.getDetailData() // 获取储值卡商品详情
      return
    }
    await this.getCardListData('Runtu') // 获取上架的储值卡列表数据
  },
  mounted() {},
  methods: {
    limitTypeChange () {
      this.$refs['form'].clearValidate(['userTotalLimit','userIntervalLimit','intervalLimitDays']);
      this.form.userTotalLimit = this.form.userIntervalLimit = this.form.intervalLimitDays = ''
    },
    commissionTypeChange () {
      this.$refs['form'].clearValidate(['storeCommission','commission','secondaryCommission']);
      this.form.storeCommission =this.form.commission = this.form.secondaryCommission =''
    },
    inviterCommissionTypeChange () {
      this.$refs['form'].clearValidate(['inviterCommission']);
      this.form.inviterCommission = ''
    },
    returnFloat(key, num) {
      if(num === '' || num === undefined){
        this.form[key] = ''
        return
      }
      num = num.toString(); // 转成字符串类型  如能确定类型 这步可省去
      if (num.indexOf(".") !== -1) {
        let [integerPart, decimalPart] = num.split(".");
        if (decimalPart.length > 2) {
          decimalPart = decimalPart.substring(0, 2);
        } else if (decimalPart.length === 1) {
          decimalPart += "0";
        }
        num = `${integerPart}.${decimalPart}`;
      } else {
        num += ".00";
      }
      this.form[key] = num;
    },
    // 获取储值卡商品详情
    async getDetailData() {
      const res = await api_getValueCardStoreDetail({skuId: this.$route.query.skuId})
      await this.getCardListData() // 获取上架的储值卡列表数据
      let initDataKey = ['commission', 'storeCommission','inviterCommission','secondaryCommission', 'userTotalLimit', 'userIntervalLimit', 'intervalLimitDays']
      initDataKey.forEach((key)=>{
        res[key] ? '' : res[key] = ''
      })
      res.limitType = 'noLimit'
      if (res.userTotalLimit) {
        res.limitType = 'userLimit'
      }
      if (res.userIntervalLimit) {
        res.limitType = 'regionLimit'
      }
      this.form = {
        ...res,
        salesTime: [this.$moment(res.salesStartTime), this.$moment(res.salesEndTime)],
      }
      this.returnFloat('storeCommission', this.form.storeCommission)
      this.returnFloat('commission', this.form.commission)
      this.returnFloat('inviterCommission', this.form.inviterCommission)
      this.returnFloat('secondaryCommission', this.form.secondaryCommission)
      this.currentQuantity = res.quantity
      this.tableTrData = [res.storedCardTemplateVO]
      this.onValueCardChange(res.storedCardTemplateId)
    },

    // 获取上架的储值卡列表数据
    async getCardListData(type) {
      const res = await api_getEfficientValueCardList({source: 'Runtu'})
      const res1 = await api_getEfficientValueCardList({source: 'Middleground'})
      this.cardListData_rt = res
      this.cardListData_vc = res1
      type == 'Runtu' ? this.cardListData = this.cardListData_rt : this.cardListData = this.cardListData_vc
    },
    sourceChange (vlaue) {
      this.currentSelectCard = {}
      this.tableTrData = []
      this.form.amount = 0
      this.form.storedCardTemplateId = ''
      vlaue == 'Runtu' ? this.cardListData = this.cardListData_rt : this.cardListData = this.cardListData_vc
      setTimeout(() => {
        this.$refs['form'].clearValidate(['storedCardTemplateId']);
      }, 0)
    },
    // 储值卡下拉框改变
    onValueCardChange(value) {
      let cur = this.cardListData.find(item => item.id == value)
      if (cur) {
        this.currentSelectCard = cur
        this.tableTrData = [this.currentSelectCard]
        this.form.amount = this.currentSelectCard.amount
        setTimeout(() => {
          this.$refs['form'].clearValidate(['storedCardTemplateId']);
        }, 0)
      }
    },

    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.created()
        }
      })
    },

    // 创建
    async created() {
      this.submitLoading = true
      try {
        let params = {
          ...this.form,
        }
        // 上传图片
        if (this.form.picture && this.form.picture.size) {
          const { key } = await api_postFileUpload(this.form.picture, 'CardMall')
          params.picture = key
        }

        params.salesStartTime = this.form.salesTime ? this.$moment(this.form.salesTime[0]).valueOf() : null
        params.salesEndTime = this.form.salesTime ? this.$moment(this.form.salesTime[1]).valueOf() : null
        let deleteKey = ['salesTime', 'limitType']
        deleteKey.forEach(item => {
          delete params[item]
        })
        console.log('params: ', params);
        // return
        params.skuId ? await api_postValueCardStoreUpdate(params) : await api_postValueCardStoreAdd(params)
        this.$baseMessage('操作成功', 'success')
        this.onBack()
        this.submitLoading = false
      } catch (error) {
        console.log('error: ', error);
        this.submitLoading = false
      }
    },

    getUploadFile (file, name) {
      this.form[name] = file
    },
    onDeliveryChannelChange(value){
        this.form = {
          ...this.form,
          sortNum: null,
        }
    },
    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.mvc-add {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;
  .assign-day {
    display: flex;

    .el-input {
      width: 300px;
    }

    .el-form-item {
      &:last-child {
        .el-input {
          width: 200px;
          margin-left: 5px;
        }
      }
    }
  }
  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    .title-remark {
      color: #666666;
      font-size: 14px;
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }
  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 350px;
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    z-index:1000;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
  }
  .commission-remark{
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
  }

}
</style>
